export default __webpack_public_path__ + "static/media/rhcsa.7216e88a.jpg";